import { LoaderFunctionArgs } from 'react-router-dom'
import { getQuestionnairesStats } from '../../action/questionnaires'

export const questionnairesLoader = async ( args: LoaderFunctionArgs ) => {

    await getQuestionnairesStats( )

}
